import { Reveal } from "../site/Reveal";

const PHASES = [
  { title: "Computo & Preventivazione", text: "Esame meticoloso dei prezziari, verifica delle voci di capitolato e formulazione di offerte congrue e sostenibili." },
  { title: "Cantierizzazione & Sicurezza", text: "Predisposizione dell'area di cantiere, piani di sicurezza operativi e coordinamento preventivo con le maestranze." },
  { title: "Esecuzione & SAL", text: "Avanzamento controllato delle lavorazioni con emissione puntuale degli stati di avanzamento lavori per la committenza." },
  { title: "Collaudo Tecnico-Amministrativo", text: "Prove di carico, certificazioni impiantistiche, documentazione di conformità e consegna definitiva dell'opera." },
];

export const TechProcess = () => (
  <section id="registro" data-testid="process-section" className="py-20 bg-white border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-mono uppercase tracking-widest text-blue-600">Standard Operativo</span>
          <h2 className="text-3xl font-extrabold uppercase text-slate-950 mt-1">Il Disciplinare di Commessa Saircos</h2>
          <p className="text-sm text-slate-600 mt-2 font-light">
            Ogni incarico segue un iter tracciabile in quattro capitoli operativi per azzerare imprevisti e
            varianti ingiustificate.
          </p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {PHASES.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div data-testid={`phase-${i}`} className="border-t-2 border-slate-900 pt-6">
              <div className="text-xs font-mono font-bold text-blue-600 mb-2">FASE {String(i + 1).padStart(2, "0")}</div>
              <h3 className="font-bold text-slate-900 uppercase text-sm mb-2">{p.title}</h3>
              <p className="text-slate-600 text-xs leading-relaxed">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
